import { DomainError } from '../error';

const OBSERVABLE_ERROR_TYPE = 'ObservableError';

export class ObservableError extends DomainError {
    name = OBSERVABLE_ERROR_TYPE;

    render(): string {
        return this.message;
    }
}
